export const RESET_QUERY_DATA = 'RESET_QUERY_DATA';
export const SET_QUERY_DATA = 'SET_QUERY_DATA';
export const MERGE_PATIENT_DATA = 'MERGE_PATIENT_DATA';